// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"a36829db","899":"13d03e9b"}[chunkId] + ".chunk.css";
};